// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

#sidebar {
  width: 230px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1031;
  color: #fff;
  background: #213046;
  box-shadow: 0 2px 17px 2px rgba(82, 63, 105, 0.13) inset;
  overflow: hidden;
}

.main-wrapper {
  padding: 55px 0 40px;
  background: #f8f9fa;
  width: calc(100% - 230px);
  min-height: 100vh;
  position: absolute;
  right: 0;
  top: 0px;
}

.header-area {
  width: calc(100% - 60px);
  position: fixed;
  right: 0;
  top: 0px;
  z-index: 3;
}
.header-area.student {
  z-index: auto;
}

.student.header-area {
  position: relative !important;
  width: 100% !important;
}

.student.main-wrapper {
  padding: 0;
}

@media (max-width: 991.98px) {
  .wrapper #sidebar {
    width: 0;
  }
  .main-wrapper,
  .header-area,
  .student.main-wrapper {
    width: 100%;
  }
  .wrapper.sidebar-enable .student-overlay {
    position: absolute;
    background: hsla(220, 13%, 18%, 0.8);
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1020;
  }
  .wrapper.sidebar-enable #sidebar {
    width: 230px;
  }
  .wrapper.sidebar-enable #sidebar .logo {
    display: block;
  }
  .wrapper.sidebar-enable #sidebar .small_logo {
    display: none;
  }
  .wrapper.sidebar-enable #sidebar .navbar-nav .nav-item .nav-link {
    display: flex;
    align-items: center;
  }
  .wrapper.sidebar-enable #sidebar .navbar-nav .nav-item .nav-link span {
    display: block;
  }
}
@media (min-width: 992px) {
  .wrapper .main-wrapper {
    width: calc(100% - 60px);
  }
  .wrapper .main-wrapper #sidebar {
    width: 60px;
  }
  .wrapper .main-wrapper #sidebar .logo {
    display: none;
  }
  .wrapper .main-wrapper #sidebar .small_logo {
    display: block;
  }
  .wrapper .main-wrapper #sidebar .navbar-nav .nav-item .nav-link {
    display: flex;
    align-items: center;
  }
  .wrapper .main-wrapper #sidebar .navbar-nav .nav-item .nav-link span {
    display: none;
  }
  .wrapper .main-wrapper #sidebar:hover {
    width: 230px;
  }
  .wrapper .main-wrapper #sidebar:hover .logo {
    display: block;
  }
  .wrapper .main-wrapper #sidebar:hover .small_logo {
    display: none;
  }
  .wrapper .main-wrapper #sidebar:hover .navbar-nav .nav-item .nav-link {
    display: flex;
    align-items: center;
  }
  .wrapper .main-wrapper #sidebar:hover .navbar-nav .nav-item .nav-link span {
    display: block;
  }
  .wrapper.sidebar-enable .main-wrapper {
    width: calc(100% - 230px);
  }
  .wrapper.sidebar-enable .header-area {
    width: calc(100% - 230px);
  }
  .wrapper.sidebar-enable #sidebar {
    width: 230px;
  }
  .wrapper.sidebar-enable #sidebar .logo {
    display: block;
  }
  .wrapper.sidebar-enable #sidebar .small_logo {
    display: none;
  }
  .wrapper.sidebar-enable #sidebar .navbar-nav .nav-item .nav-link {
    display: flex;
    align-items: center;
  }
  .wrapper.sidebar-enable #sidebar .navbar-nav .nav-item .nav-link span {
    display: block;
  }
}
.content-wrapper {
  width: 100%;
  min-height: 100vh;
  padding-top: 20px;
}

.examtop-header .navbar-toggler {
  padding: 3px;
  font-size: 1.25rem;
  line-height: 1;
}
.examtop-header .navbar-toggler .navbar-toggler-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
}
@media (max-width: 767px) {
  .examtop-header .navbar-collapse {
    padding-top: 10px;
  }
}

#examAsidebar {
  width: 300px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1031;
  color: #fff;
  background: #f1f3f5;
  overflow: hidden;
}
#examAsidebar .sidebar-header {
  background: #aeaeae;
  border-bottom: 1px solid #a7a7a7;
}
#examAsidebar .logo {
  display: block;
}
#examAsidebar .small_logo {
  display: none;
}
#examAsidebar .questionnor_block {
  position: relative;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item {
  cursor: pointer;
  position: relative;
  font-size: 12px;
  background: #aeaeae;
  border: 1px solid #969696;
  color: #ffffff;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  line-height: 23px !important;
  text-align: center;
  margin-bottom: 14px;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.views {
  background: #ff0000;
  position: relative;
  border-radius: 2px;
  border: none;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.views::after {
  color: #ff0000;
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  top: 25px;
  left: 2px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.4em solid;
  border-right: 0.9em solid transparent;
  border-bottom: 0;
  border-left: 0.9em solid transparent;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.attempted {
  background: #3ac555;
  position: relative;
  border-radius: 2px;
  border: none;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.attempted::after {
  color: #3ac555;
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  bottom: 25px;
  left: 2px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.9em solid transparent;
  border-bottom: 0.4em solid;
  border-left: 0.9em solid transparent;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.attempted.checked {
  position: relative;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.attempted.checked::before {
  color: #fff;
  background: #28a745;
  border-radius: 50%;
  font-size: 12px;
  content: "\\f058";
  position: absolute;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-family: "Font Awesome 5 Pro";
  font-weight: 400;
  right: -6px;
  bottom: 0;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.bookmark {
  background: #36a1f5;
  position: relative;
  border: 1px solid #2695e9;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.markreview {
  background: #36a1f5;
  position: relative;
  border: 1px solid #2695e9;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.markreview.checked {
  position: relative;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.markreview.checked::before {
  color: #fff;
  background: #28a745;
  border-radius: 50%;
  font-size: 12px;
  content: "\\f058";
  position: absolute;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-family: "Font Awesome 5 Pro";
  font-weight: 400;
  right: -6px;
  bottom: 0;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item.skip {
  position: relative;
  border: 1px solid #f9c52d;
  background: #f9c52d;
}
#examAsidebar .questionnor_block .questionNos .list-inline-item:last-child {
  margin-right: 0;
}
#examAsidebar .mark_status .single_mark {
  text-align: center;
  margin-right: 2px;
  width: 100%;
}
#examAsidebar .mark_status .single_mark:last-child {
  margin-right: 0;
}
#examAsidebar .mark_status .single_mark.special-indicate {
  text-align: center;
  margin-right: 2px;
  width: 100%;
  transition: all 0.3s;
}
#examAsidebar .mark_status .single_mark.special-indicate.active, #examAsidebar .mark_status .single_mark.special-indicate:hover {
  border-top: 3px solid #0172d4 !important;
  bottom: 6px;
}
#examAsidebar .mark_status .single_mark .status_name {
  padding: 6px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 4px;
}
#examAsidebar .mark_status .single_mark .status_name,
#examAsidebar .mark_status .single_mark .status_count {
  font-size: 10px;
  color: #333333;
}
#examAsidebar .mark_status .single_mark .icon_status {
  position: relative;
  background: #aeaeae;
  border: 1px solid #969696;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 10px 0;
}
#examAsidebar .mark_status .single_mark .icon_status.views {
  background: #ff0000;
  position: relative;
  border-radius: 2px;
  border: none;
}
#examAsidebar .mark_status .single_mark .icon_status.views::after {
  color: #ff0000;
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  top: 20px;
  left: 2px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.4em solid;
  border-right: 0.6em solid transparent;
  border-bottom: 0;
  border-left: 0.6em solid transparent;
}
#examAsidebar .mark_status .single_mark .icon_status.attempted {
  background: #3ac555;
  position: relative;
  border-radius: 2px;
  border: none;
}
#examAsidebar .mark_status .single_mark .icon_status.attempted::after {
  color: #3ac555;
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  bottom: 20px;
  left: 2px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.6em solid transparent;
  border-bottom: 0.4em solid;
  border-left: 0.6em solid transparent;
}
#examAsidebar .mark_status .single_mark .icon_status.bookmark {
  background: #36a1f5;
  position: relative;
  border: 1px solid #2695e9;
}
#examAsidebar .mark_status .single_mark .icon_status.markreview {
  background: #36a1f5;
  position: relative;
  border: 1px solid #2695e9;
}
#examAsidebar .mark_status .single_mark .icon_status.markreview.checked {
  position: relative;
}
#examAsidebar .mark_status .single_mark .icon_status.markreview.checked::before {
  color: #fff;
  background: #28a745;
  border-radius: 50%;
  font-size: 12px;
  content: "\\f058";
  position: absolute;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-family: "Font Awesome 5 Pro";
  font-weight: 400;
  right: -6px;
  bottom: 0;
}
#examAsidebar .mark_status .single_mark .icon_status.skip {
  position: relative;
  border: 1px solid #f9c52d;
  background: #f9c52d;
}

.main-wrapper-section {
  padding: 50px 0 40px;
  background: #f8f9fa;
  width: calc(100% - 300px);
  min-height: 100vh;
  position: absolute;
  right: 0;
  top: 0px;
}

.header-area-section {
  width: calc(100% - 300px);
  position: fixed;
  right: 0;
  top: 0px;
  z-index: 2;
}

.sidebar-enable #examAsidebar {
  width: 300px;
}

.sidebar-enable .main-wrapper-section {
  width: 100%;
}

.sidebar-enable .header-area-section {
  width: 100%;
}

@media (max-width: 1199.98px) {
  #examAsidebar {
    width: 0;
  }
  .main-wrapper-section,
  .header-area-section,
  .student.main-wrapper-section {
    width: 100%;
  }
}
@media (min-width: 1200px) {
  .sidebar-enable .main-wrapper-section {
    width: calc(100% - 300px);
  }
  .sidebar-enable .header-area-section {
    width: calc(100% - 300px);
  }
}
.assessment-nav-filter {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #aeaeae;
  list-style: none;
}
.assessment-nav-filter li {
  display: inline-block;
  font-size: 11px;
  color: #000000;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  border-radius: 25px;
  line-height: 10px;
  width: 30%;
  margin-right: 4px;
  background-color: #ffffff;
}
.assessment-nav-filter li:last-child {
  margin-right: 0;
}
.assessment-nav-filter li:hover, .assessment-nav-filter li.active {
  color: #000000 !important;
  background: #f9c52d;
  border-color: #f9c52d;
}
.assessment-nav-filter li a {
  text-decoration: none;
  color: #000000;
  padding: 0.5rem;
}

.practice-exam-tabs-filter .nav-pills {
  position: relative;
  background: #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.practice-exam-tabs-filter .nav-pills .nav-item {
  margin-right: 8px;
}
.practice-exam-tabs-filter .nav-pills .nav-item .nav-link {
  font-weight: 400;
  color: #333333;
  padding: 0.4rem 0.75rem;
  font-size: 14px;
  border-radius: 1.5rem;
  transition: all 0.3s;
  border: transparent;
}
.practice-exam-tabs-filter .questionnor_block.filter_block .title {
  color: #000000;
}
.practice-exam-tabs-filter .questionnor_block.filter_block .list-unstyled li {
  color: #707070;
}

.notification {
  position: relative;
}
.notification .notification-nav.nav-pills .nav-item {
  margin-right: 0.45rem;
}
.notification .notification-nav.nav-pills .nav-item:last-child {
  margin-right: 0;
}
.notification .notification-nav.nav-pills .nav-item .nav-link {
  display: flex;
  align-items: center;
  color: #142031;
  font-size: 14px;
  border-radius: 0.4rem;
  padding: 0.25rem 0.65rem !important;
  transition: ease-in all 0.2s;
  border: 1px solid #f8f9fa;
}
@media screen and (max-width: 767.98px) {
  .notification .notification-nav.nav-pills .nav-item .nav-link {
    padding: 0.25rem 0.35rem !important;
    font-size: 10px;
  }
}
.notification .notification-nav.nav-pills .nav-item .nav-link i {
  position: relative;
  font-size: 14px;
  color: #142031;
}
.notification .notification-nav.nav-pills .nav-item .nav-link i i {
  color: #ffffff;
  position: absolute;
  font-size: 7px;
  left: 6px;
  top: 3px;
}
.notification .notification-nav.nav-pills .nav-item .nav-link.active, .notification .notification-nav.nav-pills .nav-item .nav-link:hover {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  padding: 0.25rem 0.65rem !important;
  background-color: #4a23c9 !important;
  border: 1px solid #3c00ff;
}
@media screen and (max-width: 767.98px) {
  .notification .notification-nav.nav-pills .nav-item .nav-link.active, .notification .notification-nav.nav-pills .nav-item .nav-link:hover {
    padding: 0.25rem 0.35rem !important;
    font-size: 10px;
  }
}
.notification-block.list-unstyled li .card {
  background: #e8e8e8;
  border: 1px solid #dedfe1;
}
.notification-block.list-unstyled li .card.unread-msge {
  background: #ffffff;
  border: 1px solid #dedfe1;
}

.practice-instructions-card {
  position: relative;
}
.practice-instructions-card .card {
  border-radius: 1rem !important;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
}
.practice-instructions-card .card:not(:last-child) {
  margin-bottom: 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
}
.practice-instructions-card .card .card-header {
  border-bottom-style: dashed;
}
.practice-instructions-card .card .light-color {
  color: #999;
}
.practice-instructions-card .card .text-dark {
  outline: none;
  box-shadow: none;
}
.practice-instructions-card .card button.btn-primary {
  font-size: 1rem;
  border: #202b63;
  background: #202b63;
  color: #ffffff;
  padding: 0.65rem 1.5rem;
}
.practice-instructions-card .card button.btn-primary:hover, .practice-instructions-card .card button.btn-primary.active {
  border: #1d2c72;
  background: #1d2c72;
  color: #ffffff;
}
@media (max-width: 991.98px) {
  .practice-instructions-card .card button.btn-primary {
    display: block;
    width: 100%;
  }
}

body {
  font-family: "proxima-nova", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 1.5;
  background: #ffffff;
}
body.modal-open {
  overflow-y: scroll !important;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700 !important;
  font-family: "proxima-nova", sans-serif !important;
}

a {
  transition: color 0.25s ease-in-out;
  text-decoration: none;
}

a,
a:hover {
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
}

a,
button {
  outline: none !important;
}

ul li {
  line-height: 25px !important;
  font-family: "proxima-nova", sans-serif !important;
}

p {
  line-height: 1.5 !important;
  font-family: "proxima-nova", sans-serif !important;
}

.btn-toolbar > * + * {
  margin-left: 0.5em;
}

.showcase-component svg {
  width: 100%;
  height: auto;
}

hr.line-style {
  border-top: 1px dashed #ced4da;
}

.css-1okebmr-indicatorSeparator {
  display: none;
}

.modal-title {
  font-family: "proxima-nova", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 25px;
}

.dropdown-item {
  font-size: 14px;
}

.form-control {
  height: 38px !important;
  font-size: 14px !important;
}

textarea.form-control {
  height: auto !important;
}

.o-hidden {
  overflow: hidden !important;
}

.react-bootstrap-table .table thead th {
  outline: none;
}

.no-arrow .dropdown-toggle {
  position: relative;
}
.no-arrow .dropdown-toggle::after {
  display: none !important;
}

.btn-circle {
  border-radius: 100% !important;
  width: 35px;
  height: 35px;
  padding: 5px;
}

.wrapper {
  height: 100%;
  width: 100%;
}

.top-header {
  margin-left: 250px;
  transition: all 0.3s;
  position: fixed !important;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  box-shadow: 0px 1px 15px hsla(0, 0%, 0%, 0.161);
}

.footer {
  background: #ffffff;
  border-top: 1px solid hsla(200, 11%, 64%, 0.2);
  color: #98a6ad;
  padding: 19px 30px 20px;
  position: absolute;
  width: 100%;
  bottom: 0;
  right: 0;
  left: 0;
}

.left-side-menu {
  width: 250px;
  height: 100vh;
  z-index: 10;
  color: #ffffff;
  background: #213046;
  bottom: 0;
  position: fixed;
  transition: all 0.2s ease-out;
  top: 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
}

.content-page {
  background: #f1f1f1;
  width: calc(100% - 250px);
  min-height: 100vh;
  transition: all 0.3s;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
  transition: all 0.3s;
}
.content-page .main-content {
  padding: 70px 20px 100px;
}

@media (max-width: 767.98px) {
  .left-side-menu {
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
    display: none;
    z-index: 10 !important;
  }
  .sidebar-enable .left-side-menu {
    display: block;
  }
  .content-page {
    transition: all 0.2s ease;
    width: 100%;
  }
  .content-page .top-header {
    margin-left: 0px;
  }
  .content-page .main-content {
    padding-bottom: 110px;
  }
  .sidebar-enable .overlay {
    position: absolute;
    background: hsla(220, 13%, 18%, 0.8);
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1020;
  }
  .footer {
    left: 0 !important;
    text-align: center;
  }
}
.page_not_found {
  min-height: 100vh;
}
.page_not_found h1 {
  animation: led 0.8s infinite;
}

@keyframes led {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/App.scss","webpack://./src/_studentmodule.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AChXA;EACE,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EAEA,gBAAA;ADkXF;;AC/WA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,QAAA;EACA,QAAA;ADiXF;;AC9WA;EACE,wBAAA;EAEA,eAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;ADgXF;AC9WE;EACE,aAAA;ADgXJ;;AC5WA;EAEE,6BAAA;EACA,sBAAA;AD8WF;;AC1WA;EACE,UAAA;AD6WF;;AC1WA;EACE;IACE,QAAA;ED6WF;EC1WA;;;IAGE,WAAA;ED4WF;ECxWE;IACE,kBAAA;IACA,oCAAA;IACA,WAAA;IACA,OAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;ED0WJ;ECvWE;IACE,YAAA;EDyWJ;ECvWI;IACE,cAAA;EDyWN;ECtWI;IACE,aAAA;EDwWN;ECrWI;IACE,aAAA;IACA,mBAAA;EDuWN;ECtWM;IACE,cAAA;EDwWR;AACF;AClWA;EACE;IACE,wBAAA;EDoWF;EClWE;IACE,WAAA;EDoWJ;ECnWI;IACE,aAAA;EDqWN;EClWI;IACE,cAAA;EDoWN;ECjWI;IACE,aAAA;IACA,mBAAA;EDmWN;ECjWM;IACE,aAAA;EDmWR;EChWI;IACE,YAAA;EDkWN;EChWM;IACE,cAAA;EDkWR;EC/VM;IACE,aAAA;EDiWR;EC9VM;IACE,aAAA;IACA,mBAAA;EDgWR;EC9VQ;IACE,cAAA;EDgWV;ECzVA;IACE,yBAAA;ED2VF;ECxVA;IACE,yBAAA;ED0VF;ECvVA;IACE,YAAA;EDyVF;ECvVE;IACE,cAAA;EDyVJ;ECtVE;IACE,aAAA;EDwVJ;ECrVE;IACE,aAAA;IACA,mBAAA;EDuVJ;ECrVI;IACE,cAAA;EDuVN;AACF;AClVA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;ADoVF;;AChVE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;ADmVJ;ACjVI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;ADmVN;AC/UE;EACE;IACE,iBAAA;EDiVJ;AACF;;AC7UA;EACE,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EAEA,mBAAA;EAGA,gBAAA;AD6UF;AC3UE;EACE,mBAAA;EACA,gCAAA;AD6UJ;AC1UE;EACE,cAAA;AD4UJ;ACzUE;EACE,aAAA;AD2UJ;ACxUE;EACE,kBAAA;AD0UJ;ACxUI;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;AD0UN;ACxUM;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AD0UR;ACxUQ;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AD0UV;ACtUM;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;ADwUR;ACtUQ;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ADwUV;ACtUQ;EACE,kBAAA;ADwUV;ACvUU;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;ADyUZ;ACpUM;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;ADsUR;ACpUM;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;ADsUR;ACrUQ;EACE,kBAAA;ADuUV;ACtUU;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;ADwUZ;ACnUM;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;ADqUR;AClUM;EACE,eAAA;ADoUR;AC/TE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;ADiUJ;AC/TI;EACE,eAAA;ADiUN;AC9TI;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;ADgUN;AC9TM;EAEE,wCAAA;EACA,WAAA;AD+TR;AC3TI;EACE,cAAA;EACA,2CAAA;EACA,kBAAA;AD6TN;AC1TI;;EAEE,eAAA;EACA,cAAA;AD4TN;ACzTI;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AD2TN;ACzTM;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AD2TR;ACzTQ;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AD2TV;ACvTM;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;ADyTR;ACvTQ;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ADyTV;ACrTM;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;ADuTR;ACrTM;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;ADuTR;ACtTQ;EACE,kBAAA;ADwTV;ACvTU;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;ADyTZ;ACpTM;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;ADsTR;;AChTA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,QAAA;EACA,QAAA;ADkTF;;AC/SA;EACE,yBAAA;EAEA,eAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;ADiTF;;AC9SA;EACE,YAAA;ADiTF;;AC9SA;EACE,WAAA;ADiTF;;AC9SA;EACE,WAAA;ADiTF;;AC9SA;EACE;IACE,QAAA;EDiTF;EC9SA;;;IAGE,WAAA;EDgTF;AACF;AC7SA;EACE;IACE,yBAAA;ED+SF;EC5SA;IACE,yBAAA;ED8SF;AACF;AC3SA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AD6SF;AC3SE;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;AD6SJ;AC3SI;EACE,eAAA;AD6SN;AC1SI;EAEE,yBAAA;EACA,mBAAA;EACA,qBAAA;AD2SN;ACxSI;EACE,qBAAA;EACA,cAAA;EACA,eAAA;AD0SN;;AClSE;EACE,kBAAA;EACA,mBAAA;EACA,mDAAA;ADqSJ;ACnSI;EACE,iBAAA;ADqSN;ACnSM;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;ADqSR;AC/RI;EACE,cAAA;ADiSN;AC9RI;EACE,cAAA;ADgSN;;AC3RA;EACE,kBAAA;AD8RF;AC5RE;EACE,qBAAA;AD8RJ;AC5RI;EACE,eAAA;AD8RN;AC3RI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,mCAAA;EACA,4BAAA;EACA,yBAAA;AD6RN;AC3RM;EAVF;IAWI,mCAAA;IACA,eAAA;ED8RN;AACF;AC5RM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AD8RR;AC5RQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;AD8RV;AC1RM;EAEE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;EACA,yBAAA;AD2RR;ACzRQ;EATF;IAUI,mCAAA;IACA,eAAA;ED4RR;AACF;ACtRI;EACE,mBAAA;EACA,yBAAA;ADwRN;ACtRM;EACE,mBAAA;EACA,yBAAA;ADwRR;;AClRA;EACE,kBAAA;ADqRF;ACnRE;EACE,8BAAA;EACA,oDAAA;ADqRJ;ACnRI;EACE,mBAAA;EACA,wDAAA;ADqRN;ACnRI;EACE,2BAAA;ADqRN;ACnRI;EACE,WAAA;ADqRN;ACnRI;EACE,aAAA;EACA,gBAAA;ADqRN;AClRI;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;ADoRN;AClRM;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;ADmRR;ACjRM;EAbF;IAcI,cAAA;IACA,WAAA;EDoRN;AACF;;AAx9BA;EACE,kDDkBY;ECjBZ,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBDHM;AC89BR;AAz9BE;EACE,6BAAA;AA29BJ;;AAv9BA;;;;;;;;;;;;EAYE,2BAAA;EACA,kDDNY;ACg+Bd;;AAv9BA;EAEE,mCAAA;EACA,qBAAA;AA09BF;;AAv9BA;;EAEE,eAAA;EACA,qBAAA;EACA,6BAAA;AA09BF;;AAv9BA;;EAEE,wBAAA;AA09BF;;AAv9BA;EACE,4BAAA;EACA,kDD7BY;ACu/Bd;;AAv9BA;EACE,2BAAA;EACA,kDDlCY;AC4/Bd;;AAv9BA;EACE,kBAAA;AA09BF;;AAv9BA;EACE,WAAA;EACA,YAAA;AA09BF;;AAv9BA;EACE,8BAAA;AA09BF;;AAv9BA;EACE,aAAA;AA09BF;;AAv9BA;EDlDI,kDAJU;EAKV,0BAAA;EACA,2BAAA;EACA,iBCgDwB;AA69B5B;;AA19BA;EACE,eAAA;AA69BF;;AA19BA;EACE,uBAAA;EACA,0BAAA;AA69BF;;AA19BA;EACE,uBAAA;AA69BF;;AA19BA;EACE,2BAAA;AA69BF;;AA39BA;EACE,aAAA;AA89BF;;AA19BA;EACE,kBAAA;AA69BF;AA39BE;EACE,wBAAA;AA69BJ;;AAx9BA;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA29BF;;AAx9BA;EACE,YAAA;EACA,WAAA;AA29BF;;AAx9BA;EACE,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,+CAAA;AA29BF;;AAx9BA;EACE,mBDjIM;ECkIN,8CAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;AA29BF;;AAx9BA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,cDhJM;ECiJN,mBAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;EACA,MAAA;EACA,6CAAA;AA29BF;;AAx9BA;EACE,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,oBAAA;AA29BF;AAz9BE;EACE,wBAAA;AA29BJ;;AAv9BA;EACE;IACE,gDAAA;IACA,aAAA;IACA,sBAAA;EA09BF;EAv9BA;IACE,cAAA;EAy9BF;EAt9BA;IACE,yBAAA;IAEA,WAAA;EAu9BF;EAr9BE;IACE,gBAAA;EAu9BJ;EAp9BE;IACE,qBAAA;EAs9BJ;EAl9BA;IACE,kBAAA;IACA,oCAAA;IACA,WAAA;IACA,OAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;EAo9BF;EAj9BA;IACE,kBAAA;IACA,kBAAA;EAm9BF;AACF;AA/8BA;EACE,iBAAA;AAi9BF;AA/8BE;EACE,4BAAA;AAi9BJ;;AA78BA;EACE;IACE,YAAA;EAg9BF;EA78BA;IACE,UAAA;EA+8BF;AACF","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import './config';\n@import './studentmodule';\n\n// Typography\n\nbody {\n  font-family: $font-family;\n  font-size: 14px !important;\n  font-weight: 400;\n  line-height: 1.5;\n  background: $white;\n\n  &.modal-open {\n    overflow-y: scroll !important;\n  }\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 700 !important;\n  font-family: $font-family;\n}\n\na {\n  -webkit-transition: color 0.25s ease-in-out;\n  transition: color 0.25s ease-in-out;\n  text-decoration: none;\n}\n\na,\na:hover {\n  cursor: pointer;\n  text-decoration: none;\n  background-color: transparent;\n}\n\na,\nbutton {\n  outline: none !important;\n}\n\nul li {\n  line-height: 25px !important;\n  font-family: $font-family;\n}\n\np {\n  line-height: 1.5 !important;\n  font-family: $font-family;\n}\n\n.btn-toolbar>*+* {\n  margin-left: .5em;\n}\n\n.showcase-component svg {\n  width: 100%;\n  height: auto;\n}\n\nhr.line-style {\n  border-top: 1px dashed #ced4da;\n}\n\n.css-1okebmr-indicatorSeparator {\n  display: none;\n}\n\n.modal-title {\n  @include fonts(600, 16px, 25px);\n}\n\n.dropdown-item {\n  font-size: 14px;\n}\n\n.form-control {\n  height: 38px !important;\n  font-size: 14px !important;\n}\n\ntextarea.form-control {\n  height: auto !important;\n}\n\n.o-hidden {\n  overflow: hidden !important;\n}\n.react-bootstrap-table .table thead th {\n  outline: none;\n}\n\n//Custom CSS\n.no-arrow .dropdown-toggle {\n  position: relative;\n\n  &::after {\n    display: none !important;\n  }\n\n}\n\n.btn-circle {\n  border-radius: 100% !important;\n  width: 35px;\n  height: 35px;\n  padding: 5px;\n}\n\n.wrapper {\n  height: 100%;\n  width: 100%;\n}\n\n.top-header {\n  margin-left: 250px;\n  transition: all 0.3s;\n  position: fixed !important;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 999;\n  box-shadow: 0px 1px 15px hsla(0, 0%, 0%, 0.161);\n}\n\n.footer {\n  background: $white;\n  border-top: 1px solid hsla(200, 11%, 64%, 0.2);\n  color: #98a6ad;\n  padding: 19px 30px 20px;\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n\n.left-side-menu {\n  width: 250px;\n  height: 100vh;\n  z-index: 10;\n  color: $white;\n  background: #213046;\n  bottom: 0;\n  position: fixed;\n  transition: all .2s ease-out;\n  top: 0;\n  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);\n}\n\n.content-page {\n  background: #f1f1f1;\n  width: calc(100% - 250px);\n  min-height: 100vh;\n  transition: all 0.3s;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 0;\n  transition: all 0.3s;\n\n  .main-content {\n    padding: 70px 20px 100px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .left-side-menu {\n    box-shadow: 0 0 35px 0 rgba(154, 161, 171, .15);\n    display: none;\n    z-index: 10 !important;\n  }\n\n  .sidebar-enable .left-side-menu {\n    display: block;\n  }\n\n  .content-page {\n    transition: all .2s ease;\n    // margin-left: 0 !important;\n    width: 100%;\n\n    .top-header {\n      margin-left: 0px;\n    }\n\n    .main-content {\n      padding-bottom: 110px;\n    }\n  }\n\n  .sidebar-enable .overlay {\n    position: absolute;\n    background: hsla(220, 13%, 18%, 0.8);\n    content: '';\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1020;\n  }\n\n  .footer {\n    left: 0 !important;\n    text-align: center;\n  }\n}\n\n// Page Not Found\n.page_not_found {\n  min-height: 100vh;\n\n  h1 {\n    animation: led .8s infinite;\n  }\n}\n\n@keyframes led {\n  from {\n    opacity: .2;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n","#sidebar {\n  width: 230px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  z-index: 1031;\n  color: #fff;\n  background: #213046;\n  box-shadow: 0 2px 17px 2px rgba(82, 63, 105, 0.13) inset;\n  // transition: all 0.3s;\n  overflow: hidden;\n}\n\n.main-wrapper {\n  padding: 55px 0 40px;\n  background: #f8f9fa;\n  width: calc(100% - 230px);\n  min-height: 100vh;\n  // transition: all 0.3s;\n  position: absolute;\n  right: 0;\n  top: 0px;\n}\n\n.header-area {\n  width: calc(100% - 60px);\n  // transition: all 0.3s;\n  position: fixed;\n  right: 0;\n  top: 0px;\n  z-index: 3;\n\n  &.student {\n    z-index: auto;\n  }\n}\n\n.student.header-area {\n  // transition: all 0.3s;\n  position: relative !important;\n  width: 100% !important;\n  // z-index: 2;\n}\n\n.student.main-wrapper {\n  padding: 0;\n}\n\n@media (max-width: 991.98px) {\n  .wrapper #sidebar {\n    width: 0;\n  }\n\n  .main-wrapper,\n  .header-area,\n  .student.main-wrapper {\n    width: 100%;\n  }\n\n  .wrapper.sidebar-enable {\n    .student-overlay {\n      position: absolute;\n      background: hsla(220, 13%, 18%, 0.8);\n      content: \"\";\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n      z-index: 1020;\n    }\n\n    #sidebar {\n      width: 230px;\n\n      .logo {\n        display: block;\n      }\n\n      .small_logo {\n        display: none;\n      }\n\n      .navbar-nav .nav-item .nav-link {\n        display: flex;\n        align-items: center;\n        span {\n          display: block;\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 992px) {\n  .wrapper .main-wrapper {\n    width: calc(100% - 60px);\n\n    #sidebar {\n      width: 60px;\n      .logo {\n        display: none;\n      }\n\n      .small_logo {\n        display: block;\n      }\n\n      .navbar-nav .nav-item .nav-link {\n        display: flex;\n        align-items: center;\n\n        span {\n          display: none;\n        }\n      }\n      &:hover {\n        width: 230px;\n\n        .logo {\n          display: block;\n        }\n\n        .small_logo {\n          display: none;\n        }\n\n        .navbar-nav .nav-item .nav-link {\n          display: flex;\n          align-items: center;\n\n          span {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n\n  .wrapper.sidebar-enable .main-wrapper {\n    width: calc(100% - 230px);\n  }\n\n  .wrapper.sidebar-enable .header-area {\n    width: calc(100% - 230px);\n  }\n\n  .wrapper.sidebar-enable #sidebar {\n    width: 230px;\n\n    .logo {\n      display: block;\n    }\n\n    .small_logo {\n      display: none;\n    }\n\n    .navbar-nav .nav-item .nav-link {\n      display: flex;\n      align-items: center;\n\n      span {\n        display: block;\n      }\n    }\n  }\n}\n\n.content-wrapper {\n  width: 100%;\n  min-height: 100vh;\n  padding-top: 20px;\n}\n\n.examtop-header {\n  .navbar-toggler {\n    padding: 3px;\n    font-size: 1.25rem;\n    line-height: 1;\n\n    .navbar-toggler-icon {\n      display: inline-block;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .navbar-collapse {\n      padding-top: 10px;\n    }\n  }\n}\n\n#examAsidebar {\n  width: 300px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  z-index: 1031;\n  color: #fff;\n  // background: #c1c1c1;\n  background: #f1f3f5;\n  // box-shadow: 0 2px 17px 2px rgba(82, 63, 105, 0.13) inset;\n  // transition: all 0.3s;\n  overflow: hidden;\n\n  .sidebar-header {\n    background: #aeaeae;\n    border-bottom: 1px solid #a7a7a7;\n  }\n\n  .logo {\n    display: block;\n  }\n\n  .small_logo {\n    display: none;\n  }\n\n  .questionnor_block {\n    position: relative;\n\n    .questionNos .list-inline-item {\n      cursor: pointer;\n      position: relative;\n      font-size: 12px;\n      background: #aeaeae;\n      border: 1px solid #969696;\n      color: #ffffff;\n      width: 25px;\n      height: 25px;\n      border-radius: 50%;\n      line-height: 23px !important;\n      text-align: center;\n      margin-bottom: 14px;\n\n      &.views {\n        background: #ff0000;\n        position: relative;\n        border-radius: 2px;\n        border: none;\n\n        &::after {\n          color: #ff0000;\n          position: absolute;\n          display: inline-block;\n          width: 0;\n          height: 0;\n          top: 25px;\n          left: 2px;\n          vertical-align: 0.255em;\n          content: \"\";\n          border-top: 0.4em solid;\n          border-right: 0.9em solid transparent;\n          border-bottom: 0;\n          border-left: 0.9em solid transparent;\n        }\n      }\n\n      &.attempted {\n        background: #3ac555;\n        position: relative;\n        border-radius: 2px;\n        border: none;\n\n        &::after {\n          color: #3ac555;\n          position: absolute;\n          display: inline-block;\n          width: 0;\n          height: 0;\n          bottom: 25px;\n          left: 2px;\n          vertical-align: 0.255em;\n          content: \"\";\n          border-top: 0;\n          border-right: 0.9em solid transparent;\n          border-bottom: 0.4em solid;\n          border-left: 0.9em solid transparent;\n        }\n        &.checked {\n          position: relative;\n          &::before {\n            color: #fff;\n            background: #28a745;\n            border-radius: 50%;\n            font-size: 12px;\n            content: \"\\f058\";\n            position: absolute;\n            display: inline-block;\n            font-style: normal;\n            font-variant: normal;\n            text-rendering: auto;\n            line-height: 1;\n            font-family: \"Font Awesome 5 Pro\";\n            font-weight: 400;\n            right: -6px;\n            bottom: 0;\n          }\n        }\n      }\n\n      &.bookmark {\n        background: #36a1f5;\n        position: relative;\n        border: 1px solid #2695e9;\n      }\n      &.markreview {\n        background: #36a1f5;\n        position: relative;\n        border: 1px solid #2695e9;\n        &.checked {\n          position: relative;\n          &::before {\n            color: #fff;\n            background: #28a745;\n            border-radius: 50%;\n            font-size: 12px;\n            content: \"\\f058\";\n            position: absolute;\n            display: inline-block;\n            font-style: normal;\n            font-variant: normal;\n            text-rendering: auto;\n            line-height: 1;\n            font-family: \"Font Awesome 5 Pro\";\n            font-weight: 400;\n            right: -6px;\n            bottom: 0;\n          }\n        }\n      }\n\n      &.skip {\n        position: relative;\n        border: 1px solid #f9c52d;\n        background: #f9c52d;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .mark_status .single_mark {\n    text-align: center;\n    margin-right: 2px;\n    width: 100%;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &.special-indicate {\n      text-align: center;\n      margin-right: 2px;\n      width: 100%;\n      transition: all 0.3s;\n\n      &.active,\n      &:hover {\n        border-top: 3px solid #0172d4 !important;\n        bottom: 6px;\n      }\n    }\n\n    .status_name {\n      padding: 6px 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n      margin-bottom: 4px;\n    }\n\n    .status_name,\n    .status_count {\n      font-size: 10px;\n      color: #333333;\n    }\n\n    .icon_status {\n      position: relative;\n      background: #aeaeae;\n      border: 1px solid #969696;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      margin: 10px 0;\n\n      &.views {\n        background: #ff0000;\n        position: relative;\n        border-radius: 2px;\n        border: none;\n\n        &::after {\n          color: #ff0000;\n          position: absolute;\n          display: inline-block;\n          width: 0;\n          height: 0;\n          top: 20px;\n          left: 2px;\n          vertical-align: 0.255em;\n          content: \"\";\n          border-top: 0.4em solid;\n          border-right: 0.6em solid transparent;\n          border-bottom: 0;\n          border-left: 0.6em solid transparent;\n        }\n      }\n\n      &.attempted {\n        background: #3ac555;\n        position: relative;\n        border-radius: 2px;\n        border: none;\n\n        &::after {\n          color: #3ac555;\n          position: absolute;\n          display: inline-block;\n          width: 0;\n          height: 0;\n          bottom: 20px;\n          left: 2px;\n          vertical-align: 0.255em;\n          content: \"\";\n          border-top: 0;\n          border-right: 0.6em solid transparent;\n          border-bottom: 0.4em solid;\n          border-left: 0.6em solid transparent;\n        }\n      }\n\n      &.bookmark {\n        background: #36a1f5;\n        position: relative;\n        border: 1px solid #2695e9;\n      }\n      &.markreview {\n        background: #36a1f5;\n        position: relative;\n        border: 1px solid #2695e9;\n        &.checked {\n          position: relative;\n          &::before {\n            color: #fff;\n            background: #28a745;\n            border-radius: 50%;\n            font-size: 12px;\n            content: \"\\f058\";\n            position: absolute;\n            display: inline-block;\n            font-style: normal;\n            font-variant: normal;\n            text-rendering: auto;\n            line-height: 1;\n            font-family: \"Font Awesome 5 Pro\";\n            font-weight: 400;\n            right: -6px;\n            bottom: 0;\n          }\n        }\n      }\n\n      &.skip {\n        position: relative;\n        border: 1px solid #f9c52d;\n        background: #f9c52d;\n      }\n    }\n  }\n}\n\n.main-wrapper-section {\n  padding: 50px 0 40px;\n  background: #f8f9fa;\n  width: calc(100% - 300px);\n  min-height: 100vh;\n  // transition: all 0.3s;\n  position: absolute;\n  right: 0;\n  top: 0px;\n}\n\n.header-area-section {\n  width: calc(100% - 300px);\n  // transition: all 0.3s;\n  position: fixed;\n  right: 0;\n  top: 0px;\n  z-index: 2;\n}\n\n.sidebar-enable #examAsidebar {\n  width: 300px;\n}\n\n.sidebar-enable .main-wrapper-section {\n  width: 100%;\n}\n\n.sidebar-enable .header-area-section {\n  width: 100%;\n}\n\n@media (max-width: 1199.98px) {\n  #examAsidebar {\n    width: 0;\n  }\n\n  .main-wrapper-section,\n  .header-area-section,\n  .student.main-wrapper-section {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .sidebar-enable .main-wrapper-section {\n    width: calc(100% - 300px);\n  }\n\n  .sidebar-enable .header-area-section {\n    width: calc(100% - 300px);\n  }\n}\n\n.assessment-nav-filter {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background: #aeaeae;\n  list-style: none;\n\n  li {\n    display: inline-block;\n    font-size: 11px;\n    color: #000000;\n    font-weight: bold;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 25px;\n    line-height: 10px;\n    width: 30%;\n    margin-right: 4px;\n    background-color: #ffffff;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &:hover,\n    &.active {\n      color: #000000 !important;\n      background: #f9c52d;\n      border-color: #f9c52d;\n    }\n\n    a {\n      text-decoration: none;\n      color: #000000;\n      padding: 0.5rem;\n    }\n  }\n}\n\n.practice-exam-tabs-filter {\n  // background: #f1f3f5;\n\n  .nav-pills {\n    position: relative;\n    background: #f1f3f5;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n\n    .nav-item {\n      margin-right: 8px;\n\n      .nav-link {\n        font-weight: 400;\n        color: #333333;\n        padding: 0.4rem 0.75rem;\n        font-size: 14px;\n        border-radius: 1.5rem;\n        transition: all 0.3s;\n        border: transparent;\n      }\n    }\n  }\n\n  .questionnor_block.filter_block {\n    .title {\n      color: #000000;\n    }\n\n    .list-unstyled li {\n      color: #707070;\n    }\n  }\n}\n\n.notification {\n  position: relative;\n\n  .notification-nav.nav-pills .nav-item {\n    margin-right: 0.45rem;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    .nav-link {\n      display: flex;\n      align-items: center;\n      color: #142031;\n      font-size: 14px;\n      border-radius: 0.4rem;\n      padding: 0.25rem 0.65rem !important;\n      transition: ease-in all 0.2s;\n      border: 1px solid #f8f9fa;\n\n      @media screen and (max-width: 767.98px) {\n        padding: 0.25rem 0.35rem !important;\n        font-size: 10px;\n      }\n\n      i {\n        position: relative;\n        font-size: 14px;\n        color: #142031;\n\n        i {\n          color: #ffffff;\n          position: absolute;\n          font-size: 7px;\n          left: 6px;\n          top: 3px;\n        }\n      }\n\n      &.active,\n      &:hover {\n        font-size: 14px;\n        font-weight: 400;\n        color: #fff;\n        padding: 0.25rem 0.65rem !important;\n        background-color: #4a23c9 !important;\n        border: 1px solid #3c00ff;\n\n        @media screen and (max-width: 767.98px) {\n          padding: 0.25rem 0.35rem !important;\n          font-size: 10px;\n        }\n      }\n    }\n  }\n\n  &-block.list-unstyled {\n    li .card {\n      background: #e8e8e8;\n      border: 1px solid #dedfe1;\n\n      &.unread-msge {\n        background: #ffffff;\n        border: 1px solid #dedfe1;\n      }\n    }\n  }\n}\n\n.practice-instructions-card {\n  position: relative;\n\n  .card {\n    border-radius: 1rem !important;\n    box-shadow: 0px 3px 20px #00000029;\n\n    &:not(:last-child) {\n      margin-bottom: 2rem;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;\n    }\n    .card-header {\n      border-bottom-style: dashed;\n    }\n    .light-color {\n      color: #999;\n    }\n    .text-dark {\n      outline: none;\n      box-shadow: none;\n    }\n\n    button.btn-primary {\n      font-size: 1rem;\n      border: #202b63;\n      background: #202b63;\n      color: #ffffff;\n      padding: 0.65rem 1.5rem;\n\n      &:hover,\n      &.active {\n        border: #1d2c72;\n        background: #1d2c72;\n        color: #ffffff;\n      }\n      @media (max-width: 991.98px) {\n        display: block;\n        width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
